(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    customElements.whenDefined('shopify-chat').then(() => {
    document.querySelectorAll('.product-inbox-trigger').forEach((trigger) => {
      trigger.hidden = false;

      if (trigger.dataset.inboxBound === 'true') return;
      trigger.dataset.inboxBound = 'true';
      trigger.addEventListener('click', () => {
        const shopifyChat = document.querySelector('shopify-chat');
        if (!shopifyChat) return;

        shopifyChat.setAttribute('mode', 'managed');
        shopifyChat.show?.();
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
